import {HttpBackend} from '@angular/common/http';
import {FeatureTranslateLoader} from './core/i18n/feature-translate.loader';

export function multiHttpLoaderFactory(backend: HttpBackend) {
    return new FeatureTranslateLoader(backend);
}
